import { render, staticRenderFns } from "./flex-collection-minimal.vue?vue&type=template&id=408aa4da&"
import script from "./flex-collection-minimal.vue?vue&type=script&lang=js&"
export * from "./flex-collection-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports